import store from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setPremiumUserState', function setPremiumUserState(response) {
    store.isProsumerConsumerMailbox = response.isProsumerConsumerMailbox;
});
//# sourceMappingURL=setPremiumUserState.js.map